// Uclean-Admin-Dashboard/src/mocks/promo/promotionGroups/store.js

import fixtures from './fixtures.json';

export let groupsStore = [...fixtures];

export const _resetGroupsStore = () => {
  groupsStore = [...fixtures];
};
